// highlighting mode for selected dbId's (see Viewer3D.select)
export var SelectionType = {
  MIXED: 1,
  REGULAR: 2,
  OVERLAYED: 3
};